import { Box, Grid2, Stack, Typography, useTheme } from '@mui/material'
import { PencilButton } from './PencilButton';
import { getPlatform, useScreenOrientation } from '../../../../../../utilities/orientationAndPlatform';

export function LogoEntry({...params}){

    let pageMode = params.pageMode
    let channelID = params.channelID
    let logoURLState = params.logoURLState
    let setLogoURLState = params.setLogoURLState

    let theme = useTheme()

    let platform = getPlatform()
    let orientation = useScreenOrientation()
    let logoWidth = ''
    let titleTextAlignment = ''
    let titleBoxWidth = ''
    let titleBoxMinWidth = ''
    let pencilBoxWidth = ''
    if (platform === 'desktop'){
        titleTextAlignment = 'flex-end'
        
        if (pageMode === 'read'){
            logoWidth = '204px'
            titleBoxWidth = '266px'
            pencilBoxWidth = '150px'
        }

        else if (pageMode === 'edit'){
            logoWidth = '216px'
            titleBoxWidth = '281px'
            pencilBoxWidth = '123px'
        }
    }

    else if (platform === 'mobile'){

        if (pageMode === 'read'){
            logoWidth = '152px'
            titleTextAlignment = 'flex-end'
            titleBoxWidth = '166px'
            pencilBoxWidth = '100px'
        }

        else if (pageMode === 'edit'){
            logoWidth = '145px'
            titleTextAlignment = 'flex-start'
            titleBoxWidth = 'auto'
            
            if (orientation === 0) {
                pencilBoxWidth = '81px'
                titleBoxMinWidth = '199px'
            }
            else if (orientation === 90) {
                pencilBoxWidth = '83px'
                logoWidth = '166px'
                titleBoxMinWidth = '199px'
            }
        }
    }

    function loadStationLogo(e) {
        e.target.onError = null;
        e.target.style.backgroundColor = '#007CEB';
        e.target.src = "/logos/sinclair-broadcast-group-white.svg"
    }

    return(
        <>
            <Grid2 container id={'LogoEntryGrid'} flexWrap={'nowrap'}>
                <Box display={'flex'} justifyContent={'top'}  backgroundColor={theme.palette.ChannelPage.foreground} id={'LogoBox'}>
                    <Box height={'50px'}>
                        <Box
                            component="img"
                            src={logoURLState.imageSrc + '?' + logoURLState.imageHash + '.svg'}
                            alt="Station Logo"
                            onError={loadStationLogo}
                            sx={{
                                backgroundColor: "#007CEB",
                                padding: "11px",
                                height: "100%",
                                width: logoWidth,
                            }}
                        />
                    </Box>
                </Box>

                <Stack direction={'row'} flexWrap={'nowrap'} spacing={'3px'} id={'LogoEntryStack'} maxWidth={'100%'}>
                    <Box display={'flex'} justifyContent={titleTextAlignment} minWidth={titleBoxMinWidth} width={titleBoxWidth} height={'50px'} padding={'20px'} 
                        backgroundColor={theme.palette.ChannelPage.foreground} overflow={'hidden'} textOverflow={'ellipsis'} id={'TitleBox'}>
                        <Typography alignSelf={'center'} fontSize={'18px'} fontWeight={700} overflow={'hidden'} textOverflow={'ellipsis'}>Station Logo</Typography>
                    </Box>

                    {(pageMode === 'read') && (
                        <Box display={'flex'} justifyContent={'center'} width={pencilBoxWidth} height={'50px'} padding={'20px'} backgroundColor={theme.palette.ChannelPage.foreground} id={'EntryValueBox'}>
                            <Stack direction={'column'} justifyContent={'center'} zIndex={9}>
                                <Box component="img" src={"/icons/icons-shared/icon-pencil-inactive.svg"} width={'20px'} height={'20px'} className={"PencilButton"}/>
                            </Stack>
                        </Box>
                    )}

                    {(pageMode === 'edit') && (
                        <Box display={'flex'} justifyContent={'center'} gap={'3px'} height={'50px'} width={pencilBoxWidth} backgroundColor={theme.palette.ChannelPage.foreground}>
                            <PencilButton pageMode={pageMode} channelID={channelID} setLogoURLState={setLogoURLState}/>
                        </Box>
                    )}
                </Stack>
            </Grid2>
        </>
    )
}
